import { entity } from '../../content/en';

const BASE = 'https://cyberate.investments';

export const orgId = `${BASE}/#organization`;

export const organizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': orgId,
  name: entity.name,
  telephone: entity.phone,
  email: entity.email,
  address: {
    '@type': 'PostalAddress',
    streetAddress: '5/15 Field St',
    addressLocality: 'Adelaide',
    addressRegion: 'SA',
    postalCode: '5000',
    addressCountry: 'AU',
  },
});

export const webSiteSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: entity.name,
  url: BASE,
  publisher: { '@id': orgId },
});

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: item.label,
    item: item.to ? `${BASE}${item.to}` : undefined,
  })),
});

export const faqSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: { '@type': 'Answer', text: item.a },
  })),
});

export const serviceSchema = (name, description) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name,
  description,
  provider: { '@id': orgId },
});

export const contactPageSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  name: 'Contact',
  url: `${BASE}/contact`,
});

export const localBusinessSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: entity.name,
  telephone: entity.phone,
  email: entity.email,
  address: {
    '@type': 'PostalAddress',
    streetAddress: '5/15 Field St',
    addressLocality: 'Adelaide',
    addressRegion: 'SA',
    postalCode: '5000',
    addressCountry: 'AU',
  },
});
